import { render, staticRenderFns } from "./PlayerCommentsMain.vue?vue&type=template&id=7e041422&scoped=true&"
import script from "./PlayerCommentsMain.vue?vue&type=script&lang=js&"
export * from "./PlayerCommentsMain.vue?vue&type=script&lang=js&"
import style0 from "./PlayerCommentsMain.vue?vue&type=style&index=0&id=7e041422&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e041422",
  null
  
)

export default component.exports